import { Grid } from "@material-ui/core";
import React from "react";

import FilesCard from "./FilesCard";

/**
 * FilesPageコンポーネント.
 *
 * @return {object} コンポーネント
 */
function FilesPage() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <FilesCard />
      </Grid>
    </Grid>
  );
}

export default FilesPage;
